import { render, staticRenderFns } from "./FlowOtherSetting.vue?vue&type=template&id=00362cf9&scoped=true&"
import script from "./FlowOtherSetting.vue?vue&type=script&lang=js&"
export * from "./FlowOtherSetting.vue?vue&type=script&lang=js&"
import style0 from "./FlowOtherSetting.vue?vue&type=style&index=0&id=00362cf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00362cf9",
  null
  
)

export default component.exports